import { Link } from "@tanstack/react-router";
import { useEffect, useState } from "react";

export const EmptyTypeEnum = {
  PLAYED_GAMES: "PLAYED_GAMES",
  WISHLIST: "WISHLIST",
} as const;
export type EmptyTypeEnum = (typeof EmptyTypeEnum)[keyof typeof EmptyTypeEnum];

interface EmptyProps {
  isCurrentUser: boolean;
  type: EmptyTypeEnum;
  username: string;
}

export default function Empty({ isCurrentUser, type, username }: EmptyProps) {
  const [{ icon, message }, setContent] = useState<{
    icon: string;
    message: React.ReactNode;
  }>({ icon: "", message: "" });

  useEffect(() => {
    const icons = {
      [EmptyTypeEnum.PLAYED_GAMES]: "🚀",
      [EmptyTypeEnum.WISHLIST]: "👾",
    };
    const allMessages = isCurrentUser
      ? {
          [EmptyTypeEnum.PLAYED_GAMES]: [
            <>
              No experiences tracked yet.{" "}
              <Link className="underline hover:no-underline" to="/explore">
                Track an experience you&apos;ve completed!
              </Link>
            </>,
          ],
          [EmptyTypeEnum.WISHLIST]: [
            <>
              Nothing on your wishlist yet.{" "}
              <Link className="underline hover:no-underline" to="/explore">
                Add one now!
              </Link>
            </>,
          ],
        }
      : {
          [EmptyTypeEnum.PLAYED_GAMES]: [
            `${username} doesn't get out much.`,
            `${username} is just here to learn.`,
            `${username} likes to live off the grid.`,
            `${username} prefers to live vicariously.`,
          ],
          [EmptyTypeEnum.WISHLIST]: [
            `${username} has already done everything one can do.`,
            `${username} has no plans.`,
            `${username} has low expectations.`,
            `${username} is fine right where they are.`,
            "Maybe send them something they should excited about.",
            `${username} just likes to live in the moment, man.`,
            `${username} never really bought into the concept of a bucket list.`,
          ],
        };
    const messages = allMessages[type];

    setContent({
      icon: icons[type],
      message: messages[Math.floor(Math.random() * messages.length)],
    });
  }, [isCurrentUser, type, username]);

  return (
    <>
      <p className="mt-5 text-center text-34/[2em]">{icon}</p>
      <p className="text-center text-15/[2em] text-pale-lavender">{message}</p>
    </>
  );
}
